// Reopen Shopify's native consent preferences from the footer.
(() => {
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href="#preferences-cookies"]');
    if (!link) return;
    event.preventDefault();
    const showError = () => {
      let status = document.getElementById('tc-cookie-preferences-status');
      if (!status) {
        status = document.createElement('p');
        status.id = 'tc-cookie-preferences-status';
        status.setAttribute('role', 'status');
        link.parentElement.appendChild(status);
      }
      status.textContent = 'Les préférences cookies sont momentanément indisponibles. Rechargez la page puis réessayez.';
    };
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
      showError();
      return;
    }
    Promise.resolve(window.privacyBanner.showPreferences()).catch(showError);
  });
})();
